import React, { useCallback } from 'react';
import CustomTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/CustomTooltip';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { LoggedOutReturnType } from '../../../redux/loggedout';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import TooltipSisuContent from '../TooltipSisuContent/TooltipSisuContent';
import { getSisuActionKey } from './actionKey';

interface Props {
  restrictedActionName: ReferralType;
  returnTo?: string;
  returnType?: LoggedOutReturnType;
  children: React.ReactNode;
}

const SisuActionPopover: React.FC<Props> = ({
  restrictedActionName,
  returnTo,
  returnType,
  children,
}) => {
  const isSisuPopoverEnabled = useFlag('sisu_popover');
  const { sendUserToJoinPage } = useRestrictToLoggedIn();

  const onJoinClick = useCallback(() => {
    sendUserToJoinPage(restrictedActionName, returnTo, returnType);
  }, [restrictedActionName, returnTo, returnType, sendUserToJoinPage]);

  if (!isSisuPopoverEnabled) {
    return <>{children}</>;
  }

  return (
    <CustomTooltip
      placement="top"
      content={
        <TooltipSisuContent actionKey={getSisuActionKey(restrictedActionName)} onJoinClick={onJoinClick} />
      }
    >
      {children}
    </CustomTooltip>
  );
};

SisuActionPopover.displayName = 'SisuActionPopover';

export default SisuActionPopover;
